import TextField from '@mui/material/TextField';
import { useState } from 'react';
import globals from '../../globals';


const TextFieldRegister = ({ labelName, idName, helperText, inputProps, onChange }) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState('');
    const [error, setError] = useState(false);

    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        setValue(e.target.value);
        if (e.target.validity.valid) {
            setError(false);
        } else {
            setError(true);
        }
    }

    return (
        <TextField
            required
            autoComplete='off'
            fullWidth
            id={idName}
            label={focused || value ? '' : labelName}
            variant="outlined"
            value={value}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={handleChange}
            error={error}
            helperText={
                error ? helperText : ""
            }
            inputProps={
                inputProps
            }
            sx={{
                width: '100vh',
                borderRadius: 1,
                color: globals.colors.textColor,
                '& .MuiOutlinedInput-root': {
                    '& .MuiInputBase-input':{
                        backgroundColor: globals.colors.backgroundColor,
                    },
                    '& fieldset': {
                        borderColor: globals.colors.darkRed, // default border color
                    },
                    '&:hover fieldset': {

                        borderColor: globals.colors.darkRed, // border color on hover
                    },
                    '&.Mui-focused fieldset': {

                        borderColor: globals.colors.darkRed, // border color when focused
                    },
                },
            }}
        />
    );
};

export default TextFieldRegister;